"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

function truncatePreview(preview) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 180;
  if (!preview) return '';
  var stripped = preview.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  return stripped.length > max ? "".concat(stripped.slice(0, max).trim(), "\u2026") : stripped;
}

var ArticleComponent = function ArticleComponent(_ref) {
  var _component$articles;

  var component = _ref.component,
      onSourceClick = _ref.onSourceClick;
  if (!((_component$articles = component.articles) !== null && _component$articles !== void 0 && _component$articles.length)) return null;
  return (0, _preact.h)("div", {
    className: "forethought-agent__sources"
  }, (0, _preact.h)("div", {
    className: "forethought-agent__sources-heading"
  }, "Sources (", component.articles.length, ")"), (0, _preact.h)("div", {
    className: "forethought-agent__sources-list"
  }, component.articles.map(function (article) {
    return (0, _preact.h)("a", {
      key: article.document_id || article.link,
      className: "forethought-agent__source-card",
      href: (0, _absoluteUrlRuntime.resolveUrl)(article.link),
      target: "_blank",
      rel: "noreferrer",
      onClick: function onClick() {
        return onSourceClick === null || onSourceClick === void 0 ? void 0 : onSourceClick(article);
      }
    }, (0, _preact.h)("div", {
      className: "forethought-agent__source-title"
    }, article.title), (0, _preact.h)("div", {
      className: "forethought-agent__source-preview"
    }, truncatePreview(article.preview)), (0, _preact.h)("div", {
      className: "forethought-agent__source-meta"
    }, article.source_type));
  })));
};

var _default = ArticleComponent;
exports.default = _default;